<template>
  <div id="app" class="layui-fluid">
        <HeadIndex :serveHost="serveHost" />
        <div id="appView">
          <transition name="slide-fade">
            <router-view :serveHost="serveHost"></router-view>
          </transition>
        </div>
        <ButtomIndex :serveHost="serveHost" />
        <el-tooltip class="item" effect="dark" content="返回顶部" placement="left-start" style="right:10px;">
          <div id="backTop" @click="backTop">
              <i class="el-icon-caret-top"></i>
          </div>
        </el-tooltip>
  </div>
</template>

<script>
import HeadIndex from './components/HeadIndex.vue'
import ButtomIndex from './components/ButtomIndex.vue'

export default {
  name: 'app',
  components: {
    HeadIndex,
    ButtomIndex
  },
  data() {
    return {
      serveHost: process.env.VUE_APP_URL
    };
  },
  methods:{
    ScrollTop:function(number = 0, time){
        if (!time) {
            document.body.scrollTop = document.documentElement.scrollTop = number;
            return number;
        }
        const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
        let spacingInex = time / spacingTime; // 计算循环的次数
        let nowTop = document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
        let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
        let scrollTimer = setInterval(() => {
            if (spacingInex > 0) {
                spacingInex--;
                this.ScrollTop(nowTop += everTop);
            } else {
                clearInterval(scrollTimer); // 清除计时器
            }
        }, spacingTime);
    },
    backTop:function() {
      this.ScrollTop(0, 200);
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      var w = document.documentElement.clientWidth;
      // console.log(document.documentElement.clientWidth);
      if(w < 768) {
        window.location.href = "/pages/mobileIndex.html";
      }
    }
  },
  created() {
    var w = document.documentElement.clientWidth;
    if(w < 768) {
      window.location.href = "/pages/mobileIndex.html";
    }
    window.onscroll = function() {
       let top = document.documentElement.scrollTop;
       if(top >= 200) {
          $('#backTop').fadeIn(.3);
       } else {
          $('#backTop').fadeOut(.3);
       }
    }
  }
}
</script>

<style scoped>
#appView {
  min-height: 800px;
}
#backTop {
  position: fixed;
  bottom:100px;
  right:20px;
  height: 40px;
  width: 40px;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0,0,0, .12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
  font-size:1.2rem;
  cursor: pointer;
  transition: all .3s ease-in;
  z-index:999;
}
#backTop:hover{
  background-color:#1989fa;
  color:#fff;
} 
#app {
  overflow-y: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  transition: all 3s ease;
}
.layui-fluid{
  padding:0;
}
</style>
